<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <p>Select one of the options as a winner for your split test.</p>
        </div>
        <div class="grid-item grid-item-full" v-for="(btn, index) in options" :key="index">
            <v-radio
                :group="groupName"
                :label="btn.label"
                :value="btn.version"
                :model="version"
                @update="selectVersion"/>
        </div>
    </div>
</template>

<script>
    import shortid from 'shortid';
    import {vRadio} from '@/components/form';

    export default {
        name: 'pick-winner-step',
        inject: ['registerAction', 'stepKey', 'getContext'],
        components: {vRadio},
        props: {
            attributeName: {
                type: String,
                required: true,
            },
            useName: Boolean,
            /**
             * @type {array}
             */
            versions: Array,
        },
        computed: {
            options() {
                if (this.useName) {
                    return this.versions.map(({name: label}, version) => ({
                        version,
                        label,
                    }));
                }
                return Array.from(new Array(this.versions.length))
                    .map((e, version) => ({
                        version,
                        label: `Version ${version + 1}`,
                    }));
            },
        },
        data() {
            return {
                version: this.getCurrentVersion(),
                groupName: `pick-winner-${shortid.generate()}`,
            };
        },
        methods: {
            selectVersion(version) {
                this.version = version;
            },
            register() {
                const action = {
                    attributeName: this.attributeName,
                    delegated: () => this.version,
                };
                this.registerAction(this.stepKey, action);
            },
            getCurrentVersion() {
                const ctx = this.getContext();
                if (ctx.formData && ctx.formData[this.attributeName]) {
                    return ctx.formData[this.attributeName];
                }
                return 0;
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
